// EmployeePFStatement

import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { EMPLOYEE_PF_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const EmployeePFStatement = () => {

    const [employeePFStatementData, setEmployeePFStatementData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const EmployeePFStatementColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "UAN_No",
            Header: "UAN No",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "salary_days",
            Header: "Salary Days",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "PF_Wages",
            Header: "PF Wages",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "PF_Contirbutions",
            Header: "PF Contributions",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Employee PF Statements Report " count={totalRecords}>

            <Reactable
                columns={EmployeePFStatementColumns}
                data={employeePFStatementData}
                setData={setEmployeePFStatementData}
                setTotalCount={setTotalRecords}
                url={EMPLOYEE_PF_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default EmployeePFStatement;